import React from 'react';
import createSvgIcon from '@mui/material/utils/createSvgIcon.js';

export default createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M3.4445 8.3333V3.4444H15v1.8889h1.4445V3.1111C16.4445 2.4975 15.947 2 15.3333 2H3.1111C2.4975 2 2 2.4975 2 3.1111v5.5555c0 .6137.4975 1.1112 1.1111 1.1112h1.1111V8.3333Z"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9.7778 10.8889c-.6137 0-1.1111.4974-1.1111 1.1111v5.5555c0 .6137.4974 1.1111 1.111 1.1111h11.1111c.6137 0 1.1112-.4974 1.1112-1.1111V12c0-.6137-.4975-1.1111-1.1112-1.1111zm.3333 1.4444v4.8889h10.4445v-4.8889z"
      clipRule="evenodd"
      key="1"
    />,
    <path
      fill="currentColor"
      d="M6.7778 12.7778V7.8889h11.5554v1.8889h1.4446V7.5555c0-.6136-.4974-1.1111-1.1111-1.1111H6.4445c-.6137 0-1.1112.4975-1.1112 1.1111v5.5556c0 .6136.4975 1.1111 1.1112 1.1111h1.111v-1.4444z"
      key="2"
    />,
    <rect
      width="2.2222"
      height="2.2222"
      x="2"
      y="19.7778"
      fill="currentColor"
      rx="1.1111"
      key="3"
    />,
    <rect
      width="2.2222"
      height="2.2222"
      x="5.3333"
      y="19.7778"
      fill="currentColor"
      rx="1.1111"
      key="4"
    />,
    <rect
      width="2.2222"
      height="2.2222"
      x="8.6667"
      y="19.7778"
      fill="currentColor"
      rx="1.1111"
      key="5"
    />,
    <rect
      width="2.2222"
      height="2.2222"
      x="12"
      y="19.7778"
      fill="currentColor"
      rx="1.1111"
      key="6"
    />,
    <rect
      width="2.2222"
      height="2.2222"
      x="15.3333"
      y="19.7778"
      fill="currentColor"
      rx="1.1111"
      key="7"
    />,
    <rect
      width="2.2222"
      height="2.2222"
      x="18.6667"
      y="19.7778"
      fill="currentColor"
      rx="1.1111"
      key="8"
    />,
  ],
  'DailyImagery',
);
